/* eslint-disable react-hooks/rules-of-hooks */
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Breakpoint } from './type'

export default function useResponsive(
  query: string,
  key: Breakpoint,
  start: Breakpoint | number,
  end: Breakpoint | number,
): boolean | null {
  const theme = useTheme()
  if (query === 'up') {
    const mediaUp = useMediaQuery(theme.breakpoints.up(key))
    return mediaUp
  }

  if (query === 'down') {
    const mediaDown = useMediaQuery(theme.breakpoints.down(key))
    return mediaDown
  }

  if (query === 'between') {
    const mediaBetween = useMediaQuery(theme.breakpoints.between(start, end))
    return mediaBetween
  }

  if (query === 'only') {
    const mediaOnly = useMediaQuery(theme.breakpoints.only(key))
    return mediaOnly
  }
  return null
}
